import { formatInTimeZone } from 'date-fns-tz';
/**
 * Analytics requires an ISO 8601 date time but without the sub-second portion and without the time zone offset.
 * @param date
 */
function formatISODatetimeForAnalytics(date) {
    return formatInTimeZone(date, 'UTC', "yyyy-MM-dd'T'HH:mm:ss");
}
export { formatISODatetimeForAnalytics, };
